import { FC } from 'react'
import cx from 'classnames'

import { IconProps, Icons } from '../Icon'
import { LinkProps } from '../Link'

import * as SC from './styled'

export type DownloadButtonProps = LinkProps & {
  className?: string
  details?: string
  iconProps?: IconProps
}

const DownloadButton: FC<DownloadButtonProps> = ({
  className,
  details,
  iconProps = {
    icon: Icons.download,
  },
  ...linkProps
}) => {
  return (
    <SC.Container className={cx('DownloadButton', className)} {...linkProps}>
      {iconProps && <SC._Icon {...iconProps} />}
      <SC.Label>{linkProps?.text ?? linkProps?.label}</SC.Label>
      {details && <SC.Details>{details}</SC.Details>}
    </SC.Container>
  )
}

export default DownloadButton
